import { Component } from '@angular/core';

@Component({
  selector: 'app-te-geo-country',
  templateUrl: './te-geo-country.component.html',
  styleUrls: ['./te-geo-country.component.css']
})
export class TeGeoCountryComponent {

}
